import * as React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import EditPopUpAdmin from "./EditPopUpAdmin";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { connect, useDispatch, useSelector } from "react-redux";
import { hosting, mapStateToProps } from "../../models/buscar";
import ListEdit from "./ListaEdit";
import CheckTarifaServicioList from "./CheckTarifaServicioList";
import Swal from "sweetalert2";
import {
  Accordion,
  AccordionActions,
  AccordionDetails,
  AccordionSummary,
  Button,
  Grid,
  TableBody,
  TableHead,
  Typography,
} from "@mui/material";
import axios from "axios";
import { ACTUALIZAR_LISTA } from "../../../../redux/constanst";
import { ExpandMore } from "@mui/icons-material";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

function CustomizedTables(props) {
  const dispatch = useDispatch();
  const { actualizarLista } = useSelector((state) => state.userState);

  const empresa = props.rows;

  const alerta = (datos) => {
    Swal.fire({
      title: `¿Seguro que quiere eliminar a ${datos.name}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .get(`${hosting}/mimegacall/api/delete_usuario.php?id=${datos.id}`)
          .then((response) => {
            Swal.fire(response.data.mensaje, ``, `${response.data.type}`).then(
              (result) => {
                dispatch({
                  type: ACTUALIZAR_LISTA,
                  actualizarLista: !actualizarLista,
                });
              }
            );
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    });
  };

  
  return (
    <>
      {empresa.map((row) => {
        return row.name !== "ALL" && row.levelAcc === "empresa" ? (
          <Accordion
            style={{
              width: "100%",
              margin: "10px  0px",
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMore />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              style={{
                display: "flex",
                justifyContent: "center",
                background: "rgba(0,0,0,0.2)",
              }}
            >
              <Typography
                style={{
                  marginLeft: 20,
                  fontSize: 14,
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: 10,
                  padding: 5,
                  fontWeight: "600",
                }}
              >
                {row.name}
              </Typography>
            </AccordionSummary>
            <AccordionDetails
              style={{
                display: "flex",
                justifyContent: "right",
              }}
            >
              {row.levelAcc !== "admin" ? (
                <>
                  <Button
                    style={{
                      width: "auto",
                      height: "auto",
                      backgroundColor: "red",
                      marginLeft: 20,
                      marginRight: 20,
                      marginBottom: 20,
                    }}
                    onClick={() => alerta(row)}
                    variant="contained"
                  >
                    <p style={{ fontSize: 10 }}>ELIMINAR EMPRESA</p>
                  </Button>
                  <EditPopUpAdmin
                    btnLabel={"Agregar sucursal"}
                    datos={row}
                    style={{
                      display: "flex",
                      justifyContent: "right",
                    }}
                  />
                </>
              ) : null}

              <EditPopUpAdmin btnLabel={"Editar empresa"} datos={row} />
            </AccordionDetails>
            <Accordion
              style={{
                flex: 1,
                width: "99%",
                margin: "0.5%",
                background: "rgba(0,0,0,0.2)",
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMore />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  textAlign: "right",
                }}
              >
                <Typography
                  style={{
                    marginLeft: 20,
                    fontSize: 14,
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: 10,
                    padding: 5,
                    fontWeight: "600",
                  }}
                >
                  Tarifa por servicio
                </Typography>
              </AccordionSummary>

              <AccordionActions style={{}}>
                <EditPopUpAdmin
                  style={{
                    height: 30,
                    marginLeft: 1,
                    marginRight: 1,
                    marginBottom: 1,
                  }}
                  btnLabel={"Tarifa por servicio"}
                  add={row.id}
                />
              </AccordionActions>
              <div style={{
                display: 'flex',
                justifyContent: 'end',
              }}>
             
              </div>
              
              <CheckTarifaServicioList data={row.tarifa_servicios} id_empresa={row.id} />
            </Accordion>

            <Accordion
              style={{
                flex: 1,
                width: "99%",
                margin: "0.5%",
                background: "rgba(0,0,0,0.2)",
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMore />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  textAlign: "right",
                }}
              >
                <Typography
                  style={{
                    marginLeft: 20,
                    fontSize: 14,
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: 10,
                    padding: 5,
                    fontWeight: "600",
                  }}
                >
                  Tarifa por segundo
                </Typography>
              </AccordionSummary>
              <AccordionActions style={{}}>
                <EditPopUpAdmin
                  style={{
                    height: 30,
                    marginLeft: 1,
                    marginRight: 1,
                    marginBottom: 1,
                  }}
                  btnLabel={"Agregar tarifa"}
                  add={row.id}
                />
              </AccordionActions>
              <ListEdit data={row} />
            </Accordion>
            <Grid container>
              <Grid item xs={12}>
                <Accordion
                  style={{
                    flex: 1,
                    width: "99%",
                    margin: "0% 0.5%",
                    background: "rgba(0,0,0,0.2)",
                    marginBottom: 10,
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMore />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      flex: 1,
                    }}
                  >
                    <Typography
                      style={{
                        marginLeft: 20,
                        fontSize: 14,
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: 10,
                        padding: 5,
                        fontWeight: "600",
                      }}
                    >
                      Sucursales
                    </Typography>
                  </AccordionSummary>
                  <AccordionActions
                    style={{
                      flex: 1,
                      width: "99%",
                      margin: "0.5%",
                      display: "contents",
                    }}
                  >
                    {empresa.map((row2) => {
                      if (row2.asoc.length === 0) return null;
                      return row2.levelAcc === "sucursal" &&
                        row.id === row2?.asoc[0].id &&
                        row2.asoc.length > 0 ? (
                        <Accordion
                          style={{
                            flex: 1,
                            width: "99%",
                            margin: "0.5%",
                          }}
                        >
                          <AccordionSummary
                            expandIcon={<ExpandMore />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                            style={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <Typography
                              style={{
                                marginLeft: 20,
                                fontSize: 14,
                                alignItems: "center",
                                justifyContent: "center",
                                borderRadius: 10,
                                padding: 5,
                                fontWeight: "600",
                              }}
                            >
                              {row2.name}
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              textAlign: "right",
                            }}
                          >
                            <div
                              style={{
                                textAlign: "right",
                                width: "100%",
                                display: "flex",
                                flexDirection: "row-reverse",
                              }}
                            >
                              <Button
                                style={{
                                  width: "auto",
                                  height: "auto",
                                  backgroundColor: "red",
                                  marginLeft: 20,
                                  marginRight: 20,
                                  marginBottom: 20,
                                }}
                                onClick={() => alerta(row2)}
                                variant="contained"
                              >
                                <p style={{ fontSize: 10 }}>
                                  Eliminar sucursal
                                </p>
                              </Button>
                              <EditPopUpAdmin
                                btnLabel={"Editar sucursal"}
                                datos={row2}
                              />
                            </div>
                          </AccordionDetails>
                          <div
                            style={{
                              padding: "50px 60px",
                            }}
                          >
                            <TableContainer component={Paper}>
                              <Table
                                sx={{ maxWidth: "100%" }}
                                aria-label="customized table"
                              >
                                <TableHead style={{ background: "red" }}>
                                  <TableRow>
                                    <StyledTableCell
                                      style={{ backgroundColor: "#F4796D" }}
                                    >
                                      Channel
                                    </StyledTableCell>
                                    <StyledTableCell
                                      style={{ backgroundColor: "#F4796D" }}
                                      align="center"
                                    >
                                      Extension
                                    </StyledTableCell>

                                    <StyledTableCell
                                      style={{ backgroundColor: "#F4796D" }}
                                      align="center"
                                    >
                                      Name
                                    </StyledTableCell>
                                  </TableRow>
                                </TableHead>
                                {row2.anexos.map((datos, index) => {
                                  var backgrounds = "";
                                  if (index % 2 === 0) {
                                    backgrounds = "#c2c2c2";
                                  }
                                  return (
                                    <TableBody>
                                      <StyledTableRow
                                        style={{
                                          backgroundColor: backgrounds,
                                        }}
                                      >
                                        <StyledTableCell
                                          component="th"
                                          scope="row"
                                        >
                                          SIP/{datos.extension}
                                        </StyledTableCell>
                                        <StyledTableCell align="center">
                                          {datos.extension}
                                        </StyledTableCell>

                                        <StyledTableCell align="center">
                                          {datos.name}{" "}  
                                        </StyledTableCell>
                                      </StyledTableRow>
                                    </TableBody>
                                  );
                                })}
                              </Table>
                            </TableContainer>
                          </div>
                        </Accordion>
                      ) : null;
                    })}
                  </AccordionActions>
                </Accordion>
              </Grid>
            </Grid>
          </Accordion>
        ) : null;
      })}
    </>
  );
}

export default connect(mapStateToProps, null)(CustomizedTables);
